/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {AsideMenuExternalItem} from './AsideMenuExternalItem'
import {useAuth} from '../../../../app/modules/auth'

export function AsideMenuMain() {
  const intl = useIntl()

  const {currentUser} = useAuth()

  return (
    <>
      {(() => {
        if (currentUser) {
          if (currentUser.rol == 'Admin') {
            return (
              <>
                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                      Sitio Web
                    </span>
                  </div>
                </div>
                <AsideMenuItem
                  to='/homepage'
                  icon='/media/icons/duotune/general/gen001.svg'
                  title='Inicio'
                />
                {/* <AsideMenuItem
                  to='#'
                  icon='/media/icons/duotune/general/gen006.svg'
                  title='Banners'
                /> */}
                <AsideMenuItem
                  to='/marcas'
                  icon='/media/icons/duotune/abstract/abs051.svg'
                  title='Marcas'
                />

                <AsideMenuItemWithSub
                  to='/catalogo'
                  title='Catálogo'
                  fontIcon='bi-archive'
                  icon='/media/icons/duotune/general/gen009.svg'
                >
                  {/* <AsideMenuItem to='#' title='Categorías' hasBullet={true} /> */}
                  <AsideMenuItem to='/catalogo/productos' title='Productos' hasBullet={true} />
                  <AsideMenuItem to='/catalogo/imagenes' title='Imágenes' hasBullet={true} />
                  {/* <AsideMenuItem to='#' title='Lista en Excel' hasBullet={true} /> */}
                </AsideMenuItemWithSub>
                <AsideMenuItem
                  to='/generales'
                  icon='/media/icons/duotune/general/gen019.svg'
                  title='Generales'
                />

                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                      Usuarios
                    </span>
                  </div>
                </div>
                {/* <AsideMenuItem
                  to='#'
                  icon='/media/icons/duotune/communication/com013.svg'
                  title='Administradores'
                /> */}
                {/* <AsideMenuItem
                  to='#'
                  icon='/media/icons/duotune/communication/com014.svg'
                  title='Vendedores'
                /> */}
                <AsideMenuItem
                  to='/distribuidores'
                  icon='/media/icons/duotune/ecommerce/ecm006.svg'
                  title='Distribuidores'
                />
                <AsideMenuItem
                  to='/vendedores'
                  icon='/media/icons/duotune/communication/com006.svg'
                  title='Vendedores'
                />
                <AsideMenuItem
                  to='/administradores'
                  icon='/media/icons/duotune/communication/com013.svg'
                  title='Usuarios internos'
                />

                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Portal</span>
                  </div>
                </div>
                <AsideMenuItem
                  to='/portal/pedidos'
                  icon='/media/icons/duotune/ecommerce/ecm002.svg'
                  title='Pedidos'
                />
                <AsideMenuItem
                  to='/portal/listas-precios'
                  icon='/media/icons/duotune/ecommerce/ecm008.svg'
                  title='Listas de precios'
                />
              </>
            )
          } else if (currentUser.rol == 'Gerente Comercial') {
            return (
              <>
                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                      Usuarios
                    </span>
                  </div>
                </div>
                <AsideMenuItem
                  to='/distribuidores'
                  icon='/media/icons/duotune/ecommerce/ecm006.svg'
                  title='Distribuidores'
                />
                <AsideMenuItem
                  to='/vendedores'
                  icon='/media/icons/duotune/communication/com006.svg'
                  title='Vendedores'
                />
                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Portal</span>
                  </div>
                </div>
                <AsideMenuItem
                  to='/portal/pedidos'
                  icon='/media/icons/duotune/ecommerce/ecm002.svg'
                  title='Pedidos'
                />
                <AsideMenuItem
                  to='/portal/listas-precios'
                  icon='/media/icons/duotune/ecommerce/ecm008.svg'
                  title='Listas de precios'
                />
                <AsideMenuItem
                  to='/perfil'
                  icon='/media/icons/duotune/communication/com006.svg'
                  title='Mi Perfil'
                />
              </>
            )
          } else if (currentUser.rol == 'Vendedor') {
            return (
              <>
                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                      Portal Vendedor
                    </span>
                  </div>
                </div>
                <AsideMenuItem
                  to='/portal-vendedor/mis-pedidos'
                  icon='/media/icons/duotune/ecommerce/ecm008.svg'
                  title='Mis Pedidos'
                />
                <AsideMenuItem
                  to='/portal-vendedor/mis-distribuidores'
                  icon='/media/icons/duotune/ecommerce/ecm006.svg'
                  title='Mis distribuidores'
                />
                <AsideMenuItem
                  to='/portal-vendedor/mi-perfil'
                  icon='/media/icons/duotune/communication/com006.svg'
                  title='Mi Perfil'
                />
              </>
            )
          } else if (currentUser.rol === 'Gestor de Catálogo') {
            return (
              <>
                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                      Sitio Web
                    </span>
                  </div>
                </div>
                <AsideMenuItem
                  to='/homepage'
                  icon='/media/icons/duotune/general/gen001.svg'
                  title='Inicio'
                />
                <AsideMenuItem
                  to='/marcas'
                  icon='/media/icons/duotune/abstract/abs051.svg'
                  title='Marcas'
                />
                <AsideMenuItemWithSub
                  to='/catalogo'
                  title='Catálogo'
                  fontIcon='bi-archive'
                  icon='/media/icons/duotune/general/gen009.svg'
                >
                  <AsideMenuItem to='/catalogo/productos' title='Productos' hasBullet={true} />
                  <AsideMenuItem to='/catalogo/imagenes' title='Imágenes' hasBullet={true} />
                </AsideMenuItemWithSub>
                <AsideMenuItem
                  to='/generales'
                  icon='/media/icons/duotune/general/gen019.svg'
                  title='Generales'
                />
              </>
            )
          } else if (currentUser.rol === 'Diseño') {
            return (
              <>
                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                      Sitio Web
                    </span>
                  </div>
                </div>
                <AsideMenuItem
                  to='/homepage'
                  icon='/media/icons/duotune/general/gen001.svg'
                  title='Inicio'
                />
                <AsideMenuItem
                  to='/marcas'
                  icon='/media/icons/duotune/abstract/abs051.svg'
                  title='Marcas'
                />
                <AsideMenuItemWithSub
                  to='/catalogo'
                  title='Catálogo'
                  fontIcon='bi-archive'
                  icon='/media/icons/duotune/general/gen009.svg'
                >
                  <AsideMenuItem to='/catalogo/imagenes' title='Imágenes' hasBullet={true} />
                </AsideMenuItemWithSub>
                <AsideMenuItem
                  to='/generales'
                  icon='/media/icons/duotune/general/gen019.svg'
                  title='Generales'
                />
              </>
            )
          } else if (currentUser.rol == 'Distribuidor') {
            return (
              <>
                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                      Portal Distribuidores
                    </span>
                  </div>
                </div>
                <AsideMenuItem
                  to='/portal/mis-pedidos'
                  icon='/media/icons/duotune/ecommerce/ecm002.svg'
                  title='Mis Pedidos'
                />
                <AsideMenuItem
                  to='/portal/mi-perfil'
                  icon='/media/icons/duotune/communication/com006.svg'
                  title='Mi Perfil'
                />
                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                      Centro de ayuda
                    </span>
                  </div>
                </div>
                <AsideMenuExternalItem
                  href={
                    currentUser.vendedorAsignado?.email
                      ? `mailto:${currentUser.vendedorAsignado.email}`
                      : undefined
                  }
                  disabledTitle='No hay un correo de ventas disponible para tu cuenta.'
                  icon='/media/icons/duotune/communication/com002.svg'
                  title='Contactar a Ventas'
                />
                <AsideMenuExternalItem
                  href='mailto:contacto@altrego.mx'
                  icon='/media/icons/duotune/communication/com002.svg'
                  title='Contactar a Soporte'
                />
              </>
            )
          }
        }
      })()}
      {currentUser && (
        <AsideMenuExternalItem
          href={process.env.REACT_APP_SITE_URL || 'https://altrego.mx/'}
          target='_blank'
          icon='/media/icons/duotune/general/gen001.svg'
          title='Ir al sitio web'
        />
      )}
    </>
  )
}
